var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`checkbox-label-list-item ${_vm.selected? 'selected': ''}`},[_c('check-box',{attrs:{"selected":_vm.checkbox.selected}}),_vm._v(" "),_c('label-list-item',{attrs:{"item-data":_vm.itemData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }